/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.buying.rpc.ProductRpc
 */

export let ComHubspotBuyingModelsRpcEnums;
(function (_ComHubspotBuyingModelsRpcEnums) {})(ComHubspotBuyingModelsRpcEnums || (ComHubspotBuyingModelsRpcEnums = {}));
export let ComHubspotBuyingModelsRpcProductAbstractProductRpcError;
(function (_ComHubspotBuyingModelsRpcProductAbstractProductRpcError) {})(ComHubspotBuyingModelsRpcProductAbstractProductRpcError || (ComHubspotBuyingModelsRpcProductAbstractProductRpcError = {}));
export let ComHubspotBuyingModelsRpcProductPortalstateAbstractPortalStateWithUsageError;
(function (_ComHubspotBuyingModelsRpcProductPortalstateAbstractPortalStateWithUsageError) {})(ComHubspotBuyingModelsRpcProductPortalstateAbstractPortalStateWithUsageError || (ComHubspotBuyingModelsRpcProductPortalstateAbstractPortalStateWithUsageError = {}));
export let ComHubspotBuyingModelsRpcProductPricingpagedetailsAbstractPricingPageDetailsError;
(function (_ComHubspotBuyingModelsRpcProductPricingpagedetailsAbstractPricingPageDetailsError) {})(ComHubspotBuyingModelsRpcProductPricingpagedetailsAbstractPricingPageDetailsError || (ComHubspotBuyingModelsRpcProductPricingpagedetailsAbstractPricingPageDetailsError = {}));
export let ComHubspotBuyingModelsRpcProductRecommendationsAbstractInAppRecommendationError;
(function (_ComHubspotBuyingModelsRpcProductRecommendationsAbstractInAppRecommendationError) {})(ComHubspotBuyingModelsRpcProductRecommendationsAbstractInAppRecommendationError || (ComHubspotBuyingModelsRpcProductRecommendationsAbstractInAppRecommendationError = {}));
export let ComHubspotPurchaseOptionsModelsRpc;
(function (_ComHubspotPurchaseOptionsModelsRpc) {})(ComHubspotPurchaseOptionsModelsRpc || (ComHubspotPurchaseOptionsModelsRpc = {}));
export const getProductsRpc = {
  serviceName: 'com.hubspot.buying.rpc.ProductRpc',
  rpcName: 'getProducts',
  auth: 'app',
  fingerprint: 'X2gyY1_5noGwHbmlAUeySJwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getProductsV2Rpc = {
  serviceName: 'com.hubspot.buying.rpc.ProductRpc',
  rpcName: 'getProductsV2',
  auth: 'app',
  fingerprint: 'X2gyY1_5noGwHbmlAUeySGHrRkh634Yp',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getProductInventoryRpc = {
  serviceName: 'com.hubspot.buying.rpc.ProductRpc',
  rpcName: 'getProductInventory',
  auth: 'app',
  fingerprint: 'AAAAAAAAAAAw7e7WvkfZNpwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getProductInventoryV2Rpc = {
  serviceName: 'com.hubspot.buying.rpc.ProductRpc',
  rpcName: 'getProductInventoryV2',
  auth: 'app',
  fingerprint: 'AAAAAAAAAAAw7e7WvkfZNmHrRkh634Yp',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getSeatsProductInventoryV2Rpc = {
  serviceName: 'com.hubspot.buying.rpc.ProductRpc',
  rpcName: 'getSeatsProductInventoryV2',
  auth: 'app',
  fingerprint: 'AAAAAAAAAACHTP33O5UJ5GHrRkh634Yp',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getOwnedProductsRpc = {
  serviceName: 'com.hubspot.buying.rpc.ProductRpc',
  rpcName: 'getOwnedProducts',
  auth: 'app',
  fingerprint: 'AAAAAAAAAABTQrKlhHU4ipwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAddOnsRpc = {
  serviceName: 'com.hubspot.buying.rpc.ProductRpc',
  rpcName: 'getAddOns',
  auth: 'app',
  fingerprint: 'vGIOyRUOOtAcTK6AliWoS5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAddOnsV2Rpc = {
  serviceName: 'com.hubspot.buying.rpc.ProductRpc',
  rpcName: 'getAddOnsV2',
  auth: 'app',
  fingerprint: 'vGIOyRUOOtAcTK6AliWoS2HrRkh634Yp',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getGrowthPurchaseOptionsRpc = {
  serviceName: 'com.hubspot.buying.rpc.ProductRpc',
  rpcName: 'getGrowthPurchaseOptions',
  auth: 'app',
  fingerprint: '-W1SoCcW1jNnp4JdDE88M5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getGrowthPurchaseOptionsV2Rpc = {
  serviceName: 'com.hubspot.buying.rpc.ProductRpc',
  rpcName: 'getGrowthPurchaseOptionsV2',
  auth: 'app',
  fingerprint: 'ERFOJ4WkWq9np4JdDE88M2HrRkh634Yp',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getOwnedQuantitiesRpc = {
  serviceName: 'com.hubspot.buying.rpc.ProductRpc',
  rpcName: 'getOwnedQuantities',
  auth: 'app',
  fingerprint: 'xMTB05LzVwrgqCyvfBEaQZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getOwnedQuantitiesV2Rpc = {
  serviceName: 'com.hubspot.buying.rpc.ProductRpc',
  rpcName: 'getOwnedQuantitiesV2',
  auth: 'app',
  fingerprint: 'xMTB05LzVwrgqCyvfBEaQWHrRkh634Yp',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getCurrencyRpc = {
  serviceName: 'com.hubspot.buying.rpc.ProductRpc',
  rpcName: 'getCurrency',
  auth: 'app',
  fingerprint: 'AAAAAAAAAADR3W4J-ZD9V0IvbGFwJ20M',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getCurrencyV2Rpc = {
  serviceName: 'com.hubspot.buying.rpc.ProductRpc',
  rpcName: 'getCurrencyV2',
  auth: 'app',
  fingerprint: 'AAAAAAAAAADR3W4J-ZD9V2HrRkh634Yp',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getFeatureFlagsRpc = {
  serviceName: 'com.hubspot.buying.rpc.ProductRpc',
  rpcName: 'getFeatureFlags',
  auth: 'app',
  fingerprint: 'AAAAAAAAAAA9llyZwSnPm0IvbGFwJ20M',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getFeatureFlagsV2Rpc = {
  serviceName: 'com.hubspot.buying.rpc.ProductRpc',
  rpcName: 'getFeatureFlagsV2',
  auth: 'app',
  fingerprint: 'AAAAAAAAAAA9llyZwSnPm2HrRkh634Yp',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getInAppPhoneNumberRpc = {
  serviceName: 'com.hubspot.buying.rpc.ProductRpc',
  rpcName: 'getInAppPhoneNumber',
  auth: 'app',
  fingerprint: 'ii4zwAPZgvSJvnxBO5sLIWHrRkh634Yp',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getInAppProductBadgesRpc = {
  serviceName: 'com.hubspot.buying.rpc.ProductRpc',
  rpcName: 'getInAppProductBadges',
  auth: 'app',
  fingerprint: '08RwPDYX0FPpwqK0OaEJumHrRkh634Yp',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getInAppProductTierOptionsRpc = {
  serviceName: 'com.hubspot.buying.rpc.ProductRpc',
  rpcName: 'getInAppProductTierOptions',
  auth: 'app',
  fingerprint: 'NXu71nzzyIE4WEwybynbLGHrRkh634Yp',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getInAppProductTierOptionsV2Rpc = {
  serviceName: 'com.hubspot.buying.rpc.ProductRpc',
  rpcName: 'getInAppProductTierOptionsV2',
  auth: 'app',
  fingerprint: 'dViGwYZqmlHmBUZ0HaZqX2HrRkh634Yp',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getInAppProductPlanRpc = {
  serviceName: 'com.hubspot.buying.rpc.ProductRpc',
  rpcName: 'getInAppProductPlan',
  auth: 'app',
  fingerprint: 'tYc9ZpGng2dZzm2wHHnb7GHrRkh634Yp',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPortalStateWithUsageRpc = {
  serviceName: 'com.hubspot.buying.rpc.ProductRpc',
  rpcName: 'getPortalStateWithUsage',
  auth: 'app',
  fingerprint: '-Pe5y3zf_TjE_IjQguT1o4k5qL9wqpvQ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getInAppProductConfigRpc = {
  serviceName: 'com.hubspot.buying.rpc.ProductRpc',
  rpcName: 'getInAppProductConfig',
  auth: 'app',
  fingerprint: 'iMuCCFKJZPMV5_N7_CHzdWHrRkh634Yp',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getProductUseCasesRpc = {
  serviceName: 'com.hubspot.buying.rpc.ProductRpc',
  rpcName: 'getProductUseCases',
  auth: 'app',
  fingerprint: 'NKmN02BwKb5uX-ADA6q3QWHrRkh634Yp',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getInAppRecommendationsRpc = {
  serviceName: 'com.hubspot.buying.rpc.ProductRpc',
  rpcName: 'getInAppRecommendations',
  auth: 'app',
  fingerprint: 'A4vd5_sHg_fUmIS-NBrsOzq3sQGRedUt',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getInAppRecommendationStatusRpc = {
  serviceName: 'com.hubspot.buying.rpc.ProductRpc',
  rpcName: 'getInAppRecommendationStatus',
  auth: 'app',
  fingerprint: 'A4vd5_sHg_dnliwZgzkO5zq3sQGRedUt',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const rejectInAppRecommendationRpc = {
  serviceName: 'com.hubspot.buying.rpc.ProductRpc',
  rpcName: 'rejectInAppRecommendation',
  auth: 'app',
  fingerprint: 'HfTQ2wEfqiXcy8iZRoLjTTq3sQGRedUt',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const clickedInAppRecommendationRpc = {
  serviceName: 'com.hubspot.buying.rpc.ProductRpc',
  rpcName: 'clickedInAppRecommendation',
  auth: 'app',
  fingerprint: 's5lpfLr7PyxfTNcqBebpsTq3sQGRedUt',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const processInAppRecommendationRpc = {
  serviceName: 'com.hubspot.buying.rpc.ProductRpc',
  rpcName: 'processInAppRecommendation',
  auth: 'app',
  fingerprint: 'ssKMDjqMqtc9BRnoYRaUUjq3sQGRedUt',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getInAppGrowthPurchaseOptionsForCartRpc = {
  serviceName: 'com.hubspot.buying.rpc.ProductRpc',
  rpcName: 'getInAppGrowthPurchaseOptionsForCart',
  auth: 'app',
  fingerprint: 'Py-3TiKpf38UX624ceIH2mHrRkh634Yp',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const prefetchPortalRpc = {
  serviceName: 'com.hubspot.buying.rpc.ProductRpc',
  rpcName: 'prefetchPortal',
  auth: 'app',
  fingerprint: 'AAAAAAAAAADZRvk2ZcdNAmHrRkh634Yp',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getFeatureAwarePricingRpc = {
  serviceName: 'com.hubspot.buying.rpc.ProductRpc',
  rpcName: 'getFeatureAwarePricing',
  auth: 'app',
  fingerprint: 'ZKXHjGy93FtOk_71zixSMGHrRkh634Yp',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getProductGroupsRpc = {
  serviceName: 'com.hubspot.buying.rpc.ProductRpc',
  rpcName: 'getProductGroups',
  auth: 'app',
  fingerprint: 'x35xCMMVakXeit5eYgWSL2HrRkh634Yp',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getFeatureTableRpc = {
  serviceName: 'com.hubspot.buying.rpc.ProductRpc',
  rpcName: 'getFeatureTable',
  auth: 'app',
  fingerprint: 'cFtG9EV7uP6GdabPsiAbZGHrRkh634Yp',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};